module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/DesktopModalSidePanel.3a5b5e4.png";